//==============================
// Themes Slider
//==============================

var themesSlider = $('.vineforge-themes-items');

themesSlider.slick({
  autoplay: false,
  // autoplaySpeed: 5000,
  speed: 700,
  slidesToShow: 1,
  swipeToSlide: true,
  // fade: true,
  dots: false,
  arrows: false,
  pauseOnHover: false
});

$('.vineforge-themes-nav button').click(function() {
  var thisItem = $(this);
  var thisIndex = thisItem.parent('li').index();
  themesSlider.slick('slickGoTo', thisIndex);
  $('.vineforge-themes-nav button').removeClass('active');
  thisItem.addClass('active');
});

$('.vineforge-themes-nav li:first button').addClass('active');

themesSlider.on('beforeChange', function(event, slick, currentSlide, nextSlide){
  // console.log(nextSlide);
  $('.vineforge-themes-nav button').removeClass('active');
  $('.vineforge-themes-nav li:eq(' + nextSlide + ') button').addClass('active');
});
